// opervex-frontend/src/Opervex/MaterialManagement/UnitsMeasure.js

class UnitsMeasure {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/MaterialManagement/UnitsMeasure/", data);
  }

  async update(id, data) {
    return this.#_api.put("/MaterialManagement/UnitsMeasure/" + id, data);
  }

  async findId(id) {
    return await this.#_api.get("/MaterialManagement/UnitsMeasure/" + id);
  }

  async findAll() {
    return await this.#_api.get("/MaterialManagement/UnitsMeasure");
  }

  async SearchHelpModal({ baseUnit } = {}) {
    const preFilters = [{ fieldname: "disabled", value: false }];

    if (baseUnit) preFilters.push({ operation: "AND", operator: "different", fieldname: "id", value: baseUnit });

    return {
      url: "/MaterialManagement/UnitsMeasure/SearchHelp",
      preFilters,
      schema: await this.schema(),
    };
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Unidade",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inatívo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default UnitsMeasure;
